module.exports = __webpack_public_path__ + "media/images/area/index_hero_img_sp-d558dc9be36d513fdbf420875b47ee37.jpg";